import React from 'react'
import { User, Mail } from 'lucide-react'

class UserList extends React.Component {
  getUserType(type) {
    switch (type) {
      case 'GOD': return 'Administrador';
      case 'ROOT': return 'Root';
      case 'HHRR': return 'Recursos Humanos';
      case 'CASH': return 'Contabilidad';
      case 'LIMITED': return 'Trabajador';
      default: return type || 'Sin rol';
    }
  }

  getUserRest(rest) {
    switch (Number(rest)) {
      case 30: return '30 min';
      case 60: return '1 hora';
      default: return 'Sin descanso';
    }
  }

  render() {
    if (!this.props.users) {
      return null;
    }

    return (
      <div className="users-grid">
        {this.props.users.map(user => (
          <div key={user._id} className="user-card">
            <div className="user-card-header">
              <div className="user-avatar">
                <img
                  src={`https://vacway-images.s3.eu-central-1.amazonaws.com/${user.fullname}.png`}
                  alt={user.fullname}
                  style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div style={{ display: 'none', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' }}>
                  <User size={24} />
                </div>
              </div>
              <div className="user-info">
                <h3 className="user-name">{user.fullname}</h3>
                <p className="user-email">
                  <Mail size={14} className="mr-1" />
                  {user.email}
                </p>
              </div>
            </div>

            <div className="user-card-body">
              <div className="user-details">
                <div className="detail-item">
                  <small><strong>Tipo:</strong> {this.getUserType(user.type)}</small>
                </div>
                <div className="detail-item">
                  <small><strong>Jornada:</strong> {user.workingday}h semanales</small>
                </div>
                <div className="detail-item">
                  <small><strong>Descanso:</strong> {this.getUserRest(user.rest)}</small>
                </div>
                <div className="detail-item">
                  <small>
                    <strong>Estado:</strong>{' '}
                    <span style={{
                      display: 'inline-block', padding: '2px 8px', borderRadius: 10, fontSize: '0.78rem',
                      background: user.active ? '#e8f8e8' : '#f5f5f5',
                      color: user.active ? '#0bb937' : '#999', fontWeight: 700,
                    }}>
                      {user.active ? 'Activo' : 'Inactivo'}
                    </span>
                  </small>
                </div>
              </div>
            </div>

            <div className="user-card-footer">
              <span className="btn-edit" onClick={(e) => this.props.onEditUser(user, e)}>
                <i className="fas fa-edit mr-2"></i>
                Editar usuario
              </span>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default UserList

